import {
  ManualAdjustmentKey,
  PROPERTY_GRID_SUBJECT_PROPERTY,
  UnitRateKey,
} from '@aloft/toolkit-shared';

import { RefObject, useContext, useEffect } from 'react';

import { setFocusedPropertyGridCellKey } from '../../../../redux/features/uiSlice.ts';
import { useAppDispatch } from '../../../../redux/hooks.ts';
import { PropertyGridFocusContext } from '../../PropertyGridFocusContext.ts';
import { PropertyGridCellKey, PropertyGridFieldName } from '../../types.ts';

type PropertyGridCellKeyId =
  | PropertyGridFieldName
  | UnitRateKey
  | ManualAdjustmentKey
  | 'totalCostToCure';

type UsePropertyGridCellFocusParams = {
  cellKeyId: PropertyGridCellKeyId;
  propertyId: string;
  fieldRef: RefObject<HTMLElement>;
};

type UsePropertyGridCellFocusResult = {
  isAlertTarget: boolean;
  clearAlertTarget: () => void;
};

export const usePropertyGridCellFocus = ({
  cellKeyId,
  propertyId,
  fieldRef,
}: UsePropertyGridCellFocusParams): UsePropertyGridCellFocusResult => {
  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;
  const cellKey: PropertyGridCellKey = isSubject
    ? `subject-${cellKeyId}`
    : `${propertyId}-${cellKeyId}`;

  const { activeTargetKey, registerField, unregisterField } = useContext(PropertyGridFocusContext);
  const isAlertTarget = activeTargetKey === cellKey;
  const dispatch = useAppDispatch();

  useEffect(() => {
    registerField(cellKey, fieldRef);
    return () => unregisterField(cellKey);
  }, [cellKey]);

  const clearAlertTarget = () => {
    if (isAlertTarget) dispatch(setFocusedPropertyGridCellKey(undefined));
  };

  return { isAlertTarget, clearAlertTarget };
};
